import { twMerge } from 'tailwind-merge';

interface InfosMessageProps {
  message?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  containerClassName?: string;
  messageClassName?: string;
}

export const InfosMessage = ({
  message,
  icon,
  children,
  containerClassName,
  messageClassName,
}: InfosMessageProps) => {
  return (
    <div
      className={twMerge(
        'flex gap-2 p-4 bg-primary text-white rounded-md w-fit max-sm:py-3 max-sm:px-3',
        containerClassName,
      )}
    >
      {!children ? (
        <>
          <div className="-mt-0.5">{icon}</div>
          <p className={messageClassName}>{message}</p>
        </>
      ) : (
        children
      )}
    </div>
  );
};
